export const membersShoices: { id: string; name: string }[] = [
	{ id: 'phone', name: 'טלפון' },
	{ id: 'email', name: 'מייל' },
];
